import { IconButton, Tooltip } from "@mui/material";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import { useNavigate } from "react-router-dom";

export default function BackButton({ to, label = "Back", sx = {} }) {
  const navigate = useNavigate();

  return (
    <Tooltip title={label}>
      <IconButton
        onClick={() => navigate(to)}
        size="small"
        sx={{
          width: 34,
          height: 34,
          borderRadius: "10px",
          border: "1.5px solid rgba(0, 51, 108, 0.18)",
          color: "#00336C",
          backgroundColor: "#ffffff",
          transition: "all 0.15s ease",
          "&:hover": {
            backgroundColor: "rgba(0, 51, 108, 0.06)",
            borderColor: "#00336C",
            transform: "translateX(-1px)",
          },
          ...sx,
        }}
      >
        <ArrowBackIosNewIcon sx={{ fontSize: 14 }} />
      </IconButton>
    </Tooltip>
  );
}
